import styles from "./SM.module.css";

const SM = ({ num, text }) => {
  return (
    <div className={styles.sm}>
      <div className={styles.headingParagraph}>
        <b className={styles.b}>{(num!=null)?num:<div className="shimmer" style={{width:'2.5rem', height:"2rem"}}></div>}</b>
        <div className={styles.thisWeekVisitors}>{text}</div>
      </div>
    </div>
  );
};

export default SM;
